/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElTable as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElTableColumn as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "ratio-details"
};
import usePreformCountComprehensive from './hooks/usePreformCountComprehensive';
export default /*#__PURE__*/_defineComponent({
  __name: 'RatioDetails',
  setup: function setup(__props) {
    var _usePreformCountCompr = usePreformCountComprehensive(),
      countDetails = _usePreformCountCompr.countDetails,
      ratioLoading = _usePreformCountCompr.ratioLoading,
      getPreformReportTable = _usePreformCountCompr.getPreformReportTable;
    // function onClickLeft() {
    //   history.back();
    // }
    onMounted(function () {
      var route = useRoute();
      var params = route.params;
      console.log('params=>', params);
      getPreformReportTable(params);
    });
    return function (_ctx, _cache) {
      var _component_el_table_column = __unplugin_components_0;
      var _component_el_table = __unplugin_components_1;
      var _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        size: "small",
        class: "table",
        border: true,
        data: _unref(countDetails)
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "stone_name",
            label: "物料"
          }), _createVNode(_component_el_table_column, {
            prop: "totalWeight",
            label: "销量(吨)"
          }), _createVNode(_component_el_table_column, {
            prop: "freight",
            label: "金额(万元)"
          }), _createVNode(_component_el_table_column, {
            prop: "carNumber",
            label: "车次"
          })];
        }),
        _: 1
      }, 8, ["data"])), [[_directive_loading, _unref(ratioLoading)]])]);
    };
  }
});